import React from 'react';
import styled from 'styled-components/macro';
import { Div } from '../../../../components/grid';

const StyledSidemenuHeader = styled(Div)`
  text-decoration: none;
  display: block;
  font-size: 12px;
  font-weight: bold;
  padding: 10px 15px;
`;

export default ({
  title,
}) => (
  <StyledSidemenuHeader>
    {title}
  </StyledSidemenuHeader>
);
